"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInfoBannerSlots = exports.default = exports.InfoBanner = void 0;
var _components = require("@ori-ui/components");
var _icons = _interopRequireWildcard(require("@ori-ui/icons"));
var Icons = _icons;
var _mui = require("@ori-ui/mui");
var _clsx = _interopRequireDefault(require("clsx"));
var _react = require("react");
var _InfoIcon = _interopRequireDefault(require("../InfoIcon"));
var _infoBannerClasses = require("./infoBannerClasses");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getInfoBannerSlots = ownerState => ({
  root: ['root'],
  content: ['content']
});
exports.getInfoBannerSlots = getInfoBannerSlots;
const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = getInfoBannerSlots(ownerState);
  const composedClasses = (0, _mui.unstable_composeClasses)(slots, _infoBannerClasses.getInfoBannerUtilityClass, classes);
  return {
    ...classes,
    ...composedClasses
  };
};
const InfoBannerRoot = (0, _mui.styled)('div', {
  name: 'InfoBanner',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.root],
  shouldForwardProp: prop => (0, _components.rootShouldForwardProp)(prop) || prop === 'classes'
})(({
  theme,
  ownerState
}) => ({
  display: 'grid',
  gridTemplateColumns: '35px 1fr',
  gap: 10,
  alignItems: 'start',
  padding: theme.spacing(4, 3),
  borderRadius: theme.shape.largeComponentRadius,
  background: theme.palette.common.white,
  color: theme.palette.text.primary,
  border: '1px solid transparent',
  fontSize: theme.typography.body1.fontSize,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 6)
  },
  ...(ownerState.showBorder && {
    border: `1px solid ${theme.palette.grey[200]}`
  })
}));
const InfoBannerContent = (0, _mui.styled)('span', {
  name: 'InfoBanner',
  slot: 'Content',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.content]
})(({
  theme,
  ownerState
}) => ({
  display: 'block',
  overflow: 'hidden',
  textAlign: 'left',
  color: theme.palette.text.primary
}));
const InfoBanner = exports.InfoBanner = /*#__PURE__*/(0, _react.forwardRef)((inProps, ref) => {
  const props = (0, _mui.useThemeProps)({
    props: inProps,
    name: 'InfoBanner'
  });
  const {
    children,
    className,
    iconName,
    component = 'div',
    showBorder = false,
    ...other
  } = props;
  const ownerState = {
    ...props,
    showBorder
  };
  const infoIcon = (0, _react.useMemo)(() => {
    if (typeof iconName === 'string') {
      const IconComponent = Icons[iconName];
      if (IconComponent) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
          fontSize: "inherit"
        });
      }
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DiscountTagFilled, {
      fontSize: "inherit"
    });
  }, [iconName]);
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(InfoBannerRoot, {
    ref: ref,
    className: (0, _clsx.default)(classes.root, className),
    ownerState: ownerState,
    as: component,
    ...other,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InfoIcon.default, {
      children: infoIcon
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(InfoBannerContent, {
      ownerState: ownerState,
      className: classes.content,
      children: children
    })]
  });
});
var _default = exports.default = InfoBanner;
